import React, { useState } from "react";
import { useDrag } from "react-dnd";
import { GripVertical } from "lucide-react";

export const SOCIAL_LINK_DND_TYPE = "SOCIAL_LINK";

/**
 * A DnD-enabled wrapper for a single social link in the socials options panel.
 * Handles drag, handlebar (on hover), and styling.
 * Pass all inner UI as children.
 */
export interface ISelectedSocialLinkProps {
  index: number;
  children: React.ReactNode;
}

export default function SelectedSocialLink ({
  index,
  children,
}: ISelectedSocialLinkProps) {
  const [hovered, setHovered] = useState(false);

  // Only the handle is the drag ref!
  const [{ isDragging }, dragRef] = useDrag({
    type: SOCIAL_LINK_DND_TYPE,
    item: { index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      className={`flex items-center gap-2 p-1 rounded group bg-white transition
        ${isDragging ? "opacity-40" : ""}`}
      style={{ boxShadow: hovered ? "0 1px 4px #bbb" : undefined }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Drag Handlebar - only appears on hover */}
      <div
        ref={dragRef}
        className={`mr-1 cursor-grab transition-opacity select-none ${
          hovered ? "opacity-100" : "opacity-0"
        }`}
        title="Drag to reorder"
        tabIndex={-1}
      >
        <GripVertical size={18} />
      </div>
      {/* Everything else is passed in as children */}
      {children}
    </div>
  );
};